import { Module } from '@nestjs/common';
import { ClientsService } from './clients.service';
import { ClientsController } from './clients.controller';
import { ClientsEntity } from '@crm/dto';
import { TypeOrmModule } from '@nestjs/typeorm';

@Module({
  controllers: [ClientsController],
  providers: [ClientsService],
  imports: [TypeOrmModule.forFeature([ClientsEntity])],
})
export class ClientsModule {}
